import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { resolver } from "../../../API/middlewares/resolveRequests";
import { getUsers } from "../../../API/store/actions/admin/userAction";
import AdminHome from "../adminHome";
import UsersAlerts from "./userAlerts";
import Lang from "../../../userPreferences/staticWords";

const UsersList = ({ userToken }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [users, setUsers] = useState(null);
  const [modalVisible, setModalVisible] = useState({
    addRole: false,
    addUserData: false,
    deleteUser: false,
    ediUser: false,
    helperData: null,
  });
  const reload = useSelector((state) => state.reload.reload);
  useEffect(() => {
    resolver(getUsers, setUsers, currentPage, 10, userToken);
  }, [currentPage, reload]);
  if (users)
    return (
      <>
        <UsersAlerts
          userToken={userToken}
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
        />
        <AdminHome
          data={users}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          title={Lang.workTeamList}
          listType={"users"}
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
        />
      </>
    );
  return <>LOADING</>;
};
export default UsersList;
